import * as Sentry from '@sentry/react';

import { isProduction, isStaging } from '@/settings/environment';

if (isProduction() || isStaging()) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_GIT_SHA,
    environment: process.env.REACT_APP_ENV,
    ignoreErrors: ['window.zE is not a function'],
    sendDefaultPii: true,
    denyUrls: [
      // deny error from hubspot: https://js.hs-analytics.net
      /https?:\/\/js\.hs-analytics\.net/,
    ],
  });
}
